let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5px8h")).then(() => parcelRequire('5hQYz'));